import React, { FC } from 'react'
import { withRouter } from 'react-router-dom'
import { IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { useHistoryNew } from '@utils'
import { Empty } from '@cps'
import './index.scss'

// interface
interface IProps {
}

const MemberBusy: FC<IProps> = ({ }) => {
  const history = useHistoryNew()

  const handleBack = () => {
    history.replace('/menu')
  }

  return (
    <IonContent className='member-busy-page'>
      <Empty
        msg={i18n.t('mkt.memberIsBusy.my')}
        desc={i18n.t('mkt.memberIsBusy.laterTryAgain')}
        iconType='dicon'
        height='80vh'
        btnText={i18n.t('newCart.continueAddProduct')}
        btnAction={handleBack}
      />
    </IonContent>
  )
}

export default withRouter(observer(MemberBusy))
